import * as LJS from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from "../globals.ts";
import { saveData } from "../utils/storage.ts";
class Player extends LJS.EngineObject {
    constructor(pos) {
        let tileIndex = 280;
        let walkingTileIndex = 281;
        let deadTileIndex = 285;
        let darkTile = LJS.tile(tileIndex, tilesize, tilesheets.DARK);
        super(pos, LJS.vec2(1), darkTile);
        this.jumpCount = 0;
        this.maxJumps = 2;
        this.jumpPressed = false;
        this.walking = false;
        // Health
        this.health = 3;
        // Invincibility after taking damage
        this.invincibleTimer = 0;
        this.blinkTick = 0;
        this.invincibilityDuration = 120;
        this.baseColor = LJS.hsl(1, 1, 1);
        // Death timer
        this.deathTimer = 30;
        this.dead = false;
        // Prevent jumping at the start when we launch the game with "Space"
        this.jumpTimer = 60;
        this.darkTile = darkTile;
        this.lightTile = LJS.tile(tileIndex, tilesize, tilesheets.LIGHT);
        this.darkWalkingTile = LJS.tile(walkingTileIndex, tilesize, tilesheets.DARK);
        this.lightWalkingTile = LJS.tile(walkingTileIndex, tilesize, tilesheets.LIGHT);
        this.darkDeadTile = LJS.tile(walkingTileIndex, tilesize, tilesheets.DARK);
        this.lightDeadTile = LJS.tile(walkingTileIndex, tilesize, tilesheets.LIGHT);
        this.jumpSound = new LJS.Sound([, , 195, .04, .01, .09, 1, .9, , 122, , , , , , , , .87, .03]);
        this.damageSound = new LJS.Sound([1.4, , 495, .02, .06, .06, 5, 1.3, -5, , , , , 1.3, , .1, .1, .98, .09]);
        this.deathSound = new LJS.Sound([, , 925, .04, .3, .6, 1, .3, , 5, -100, .1, .1]);
        this.healSound = new LJS.Sound([, , 287, .07, .1, .2, 1, 1.9, , 100, 45, 1, , .4, 8, , , .4, .28]);
        this.collideTiles = true;
        this.collideSolidObjects = true;
        this.mass = 1;
    }
    update() {
        // Handle invincibility countdown and blinking visual
        if (this.invincibleTimer > 0) {
            this.invincibleTimer--;
            // Toggle twice per 12 frames, so it blinks 5 times per second
            this.blinkTick = (this.blinkTick + 1) % 12;
            const alpha = this.blinkTick < 6 ? 0 : 1;
            this.color = new LJS.Color(this.baseColor.r, this.baseColor.g, this.baseColor.b, alpha);
            if (this.invincibleTimer <= 0) {
                // Restore base color when invincibility ends
                this.color = new LJS.Color(this.baseColor.r, this.baseColor.g, this.baseColor.b, this.baseColor.a);
                this.blinkTick = 0;
            }
        }
        // Movement controls
        const speed = 0.2;
        const jumpForce = .4;
        // Death delay - The player jumps and falls, and control is disabled
        if (this.dead) {
            this.deathTimer--;
        }
        else {
            // If we fall (go down from a platform), we count one jump so we can't do 2 double jumps in the air
            if (this.velocity.y < 0 && !this.jumpCount) {
                this.jumpCount = 1;
            }
            // Movement is disabled for 0.5 second if we take damage
            this.walking = false;
            if (this.invincibleTimer < this.invincibilityDuration - 30) {
                if (LJS.keyIsDown('ArrowLeft') || LJS.keyIsDown('KeyA')) {
                    this.velocity.x = -speed;
                    this.mirror = true; // Mirror horizontally when walking left
                    this.walking = true;
                }
                else if (LJS.keyIsDown('ArrowRight') || LJS.keyIsDown('KeyD')) {
                    this.velocity.x = speed;
                    this.mirror = false; // No mirror when walking right
                    this.walking = true;
                }
                else {
                    // Only apply friction when not invincible
                    if (this.invincibleTimer <= 0) {
                        this.velocity.x *= 0.8;
                    }
                }
                // Jump delay at the start of the level
                if (this.jumpTimer > 0) {
                    this.jumpTimer--;
                }
                // Handle jump
                if ((LJS.keyIsDown('Space') || LJS.keyIsDown('ArrowUp')) && this.jumpCount < this.maxJumps && !this.jumpPressed && !this.jumpTimer) {
                    this.velocity.y = jumpForce;
                    this.jumpCount++;
                    this.jumpPressed = true;
                    this.jumpSound.play();
                }
            }
            // Reset jump pressed flag when key is released
            if (!(LJS.keyIsDown('Space') || LJS.keyIsDown('ArrowUp'))) {
                this.jumpPressed = false;
            }
            // Switching worlds with the "X" key (disabled if we are in epilepsy-safe mode)
            if (LJS.keyWasReleased("KeyX") && !Globals.epilepsySafe) {
                Globals.world = (Globals.world == Globals.LIGHT) ? Globals.DARK : Globals.LIGHT;
            }
        }
        // If the death timer is finished, we die for real
        if (this.deathTimer <= 0) {
            Globals.gameState = 'gameOver';
        }
        // We update the depth score if we go down
        if (this.pos.y < Globals.depth) {
            Globals.depth = this.pos.y;
        }
        // Display the correct tile
        if (this.walking) {
            this.tileInfo = Globals.world == Globals.LIGHT ? this.lightWalkingTile : this.darkWalkingTile;
        }
        else if (this.dead) {
            this.tileInfo = Globals.world == Globals.LIGHT ? this.lightDeadTile : this.darkDeadTile;
        }
        else {
            this.tileInfo = Globals.world == Globals.LIGHT ? this.lightTile : this.darkTile;
        }
        // The descent speed progressively gets faster
        let descentSpeed = Globals.START_DESCENT_SPEED + (Math.floor(Math.abs(Globals.depth / 50)) * 0.01);
        descentSpeed = descentSpeed > Globals.MAX_DESCENT_SPEED ? Globals.MAX_DESCENT_SPEED : descentSpeed;
        Globals.descentSpeed = descentSpeed;
        super.update();
    }
    collideWithObject(object) {
        // Reset jump count when colliding with solid objects (ground, platforms, etc.)
        if (object.collideSolidObjects) {
            this.jumpCount = 0;
        }
        return super.collideWithObject(object);
    }
    collideWithTile(tileData, pos) {
        // Reset jump count when colliding with tiles (ground)
        this.jumpCount = 0;
        return super.collideWithTile(tileData, pos);
    }
    // If we take damage, we have some invincibility frames, and we
    // are knocked back if the parameter knockback is true
    takeDamage(damage, knockback) {
        if (this.dead) {
            return;
        }
        if (this.invincibleTimer > 0) {
            return;
        }
        this.health -= damage;
        this.invincibleTimer = this.invincibilityDuration;
        // Make the player jump if there is knockback
        if (knockback) {
            this.velocity.y = 0.25;
        }
        if (this.health <= 0) {
            this.die();
        }
        else {
            this.damageSound.play();
        }
    }
    // Player dies, we save the score and display the game over screen
    die() {
        if (this.dead) {
            return;
        }
        Globals.score = Math.ceil(Globals.depth);
        if (Globals.score < Globals.bestScore) {
            Globals.bestScore = Globals.score;
            saveData("bestScore", Globals.bestScore);
        }
        // We trigger the death animation
        this.dead = true;
        this.velocity.x = 0;
        this.velocity.y = 0.25;
        this.setCollision(false, false, false, false);
        this.deathSound.play();
    }
    heal() {
        this.health++;
        this.healSound.play();
    }
}
export default Player;
